import {
  Box,
  Button,
  Container,
  Divider,
  Grid,
  IconButton,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";

import CheckIcon from "@mui/icons-material/Check";
import CodeIcon from '@mui/icons-material/Code';
import DescriptionIcon from "@mui/icons-material/Description";
import EditButton from "@mui/icons-material/Edit";
import LinkIcon from "@mui/icons-material/Link";
import RepeatIcon from "@mui/icons-material/Repeat";
import TodayIcon from "@mui/icons-material/Today";
import Visibility from "@mui/icons-material/Visibility";
import Dialog from "@mui/material/Dialog";
import React, { useEffect, useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import Checkbox from "@mui/material/Checkbox";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import FilledInput from "@mui/material/FilledInput";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import remove from "../Assets/images/icon/denied 1.gif";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Dayjs from "dayjs";

import axios from "axios";

import Footer from "../Components/Footer";
import Header from "../Components/Header";
import Schedule_Using_Date_Time_Frequency_2 from "./Schedule_Using_Date_Time_Frequency_2";

import { Editor } from "@monaco-editor/react";
import EditNoteIcon from "@mui/icons-material/EditNote";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import { runScraperOnce } from "../Api/runScraperOnce";
import resend from "../Assets/images/icon/resend.gif";
import scheduling from "../Assets/images/icon/schedule_1.gif";
import CodeDisplayModal from "../Components/CodeDisplayModal";
import HeaderMappingBox from "../Components/HeaderMappingBox";
import { LoadingBtn } from "../Components/LoadingBtn";
import UpdateUrlModal from "../Components/UpdateUrlModal";
import apiInstance from "../apiInterceptor";
import useCodeEditorStore from "../store/codeEditorStore";
import {
  dataFormatter,
  dataFormatterOutputHistory, dateFormatter, extractLogsFromUrl, fileName,
  formatDateString,
  formatFrequencyData,
  generateCronExpression, handleApiError, isLatestObjectCompleted, jsonFilePath, transformString
} from "../utils";
import Output_History_Table from "./Output_History_Table";

import QueryBuilderIcon from '@mui/icons-material/QueryBuilder';
import Avatar from '@mui/material/Avatar';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemText from '@mui/material/ListItemText';
import DialogHeader from "../Components/DialogHeader";
import ScrappingCommands from "../Components/ScrappingCommands";


const cronRegex =
  /^((\*|([0-5]?\d)(-([0-5]?\d))?)(\/([0-5]?\d)?)?)\s+((\*|([01]?[0-9]|2[0-3])(-([01]?[0-9]|2[0-3]))?)(\/([01]?[0-9]|2[0-3]))?)\s+((\*|([0-2]?[0-9]|3[0-1])(-([0-2]?[0-9]|3[0-1]))?)(\/([0-2]?[0-9]|3[0-1]))?)\s+((\*|([1-9]|1[0-2])(-([1-9]|1[0-2]))?)(\/([1-9]|1[0-2]))?)\s+((\*|[0-7]|([0-7](,[0-7])+))(\-([0-7]))?)$/;


const rowHeight = 24;
const headerHeight = 28;

const Frequency = [
  { label: "Select Frequency" },
  { label: "Hourly" },
  { label: "Daily" },
  { label: "Weekly" },
  { label: "Monthly" },
];

const FrequencyHourly = new Array(12).fill(null).map((_, i) => ({
  label: `Every ${i + 1} Hours`,
  hourInterval: i + 1,
}));


const dataFormatterScrape = (data) => {
  return data
    .map((d, index) => ({
      index: index,
      seq: d.command_seq_id,
      command: d.command,
      xpath: d.long_xpath,
      value: d.value,
      prompts: d.prompt_info,
      comments: d.step_comment,
    }))
    .filter((d) => d.command === "scrape");
};



const Pending_Details_Page = ({ version }) => {

  const session = JSON.parse(localStorage.getItem("session")) || null;
  const location = useLocation()
  useEffect(() => {
    if (!JSON.parse(localStorage.getItem("session"))) {
      localStorage.setItem("pre-url", location.pathname)
      history.push("/signin");
    }
  }, []);

  const { urlid } = useParams();
  const history = useHistory();
  const pushVersion = version == "v2" ? "" : "v1/";
  // dropdown option
  // radio button
  const [selectedOption, setSelectedOption] = useState("b");

  const [open, setOpen] = useState(false);
  const [openHeaderspopup, setOpenHeaderspopup] = useState(false);
  const [openDownload, setOpenDownload] = useState(false);

  const [openRemovepopup, setOpenRemovepopup] = React.useState(false);
  const [confirmCornSchedulepopup, setOpenConfirmCornSchedulepopup] = useState(false);
  const [confirmSchedulePopup, setConfirmSchedulePopup] = useState(false);
  const [openRunOnce, setOpenRunOnce] = useState(false);
  const [openUpdateUrl, setOpenUpdateUrl] = useState(false);
  const [openResendforPreview2, setOpenResendforPreview2] = useState(false);
  const [usnOpen, setUsnOpen] = useState(false);
  const [openResetHeadersconfirmation, setOpenResetHeadersconfirmation] = React.useState(false); 
  const [StatusHistory,setStatusHistory] = useState("");
  const [SnapshotUrl,setSnapshotUrl] = useState();

  // state for output history
  const [outputHistoryData, setOutputHistory] = useState();

  const [currPrompt, setCurrPrompt] = useState("");
  const [currPromptAdd, setCurrPromptAdd] = useState("");

  const [activitylogs, setActivitylogs] = useState([]);
  const [openal, setOpenal] = React.useState(false);

  const handleClickOpenal = () => {
    if (activitylogs.length == 0) {
      toast.info("No activity logs found")
      return
    }
    setOpenal(true);
  };
  const handleCloseal = () => {
    setOpenal(false);
  };

  const [csure, setSure] = useState(false);
  const [csure2, setSure2] = useState(false);
  const [checkVisible, setCheckVisible] = useState(true);

  const [update, setUpdate] = useState({});
  const [temp, setTemp] = useState("");

  const [details, setDetails] = useState([]);

  const [isDownloadable, setIsDownloadable] = useState(false);

  const [isDownloadingState, setDownloadingState] = useState(false)

  const checkDownload = (data) => {
    if (data.file_download_flag) {
      setIsDownloadable(true);
    }

  };

  const [fileData, setFileData] = useState({
    data: {},
    id: null,
  });

  const [expvalues] = useState({
    date: Dayjs(),
    time: Dayjs(),
    frequency: Frequency[0].label,
    hourInterval: FrequencyHourly[0].hourInterval,
    weeklyInterval: {
      Monday: false,
      Tuesday: false,
      Wednesday: false,
      Thursday: false,
      Friday: false,
      Saturday: false,
      Sunday: false,
    },
  });

  const { handleOpenEditor } = useCodeEditorStore()

  const [openResendforPreview, setOpenResendforPreview] = React.useState(false);

  const [dataKeys, setDataKeys] = useState([]);
  const [mappingOptions, setMappingOptions] = useState([]);
  const [keyValueMap, setKeyValueMap] = useState({});
  const [keyValueMapFinal, setKeyValueMapFinal] = useState({});
  const [isSinglePage, setIsSinglePage] = useState(false);

  const handleDataKeyChange = (key, value) => {
    setKeyValueMap((prevValues) => ({
      ...prevValues,
      [key]: value,
    }));
  };

  const handleRemoveOption = (labelToRemove) => {
    setMappingOptions((prevOptions) =>
      prevOptions.filter((option) => option.label !== labelToRemove)
    );
  };

  const handleApplyMapping = async (data, value) => {
    if (value == "" || !value) {
      toast.info("Please enter a value first", {
        position: "bottom-right",
      });
      return;
    }
    const specialCharactersRegex = /[!@#\$%\^\&*\)\(+=._-]+/;
    if (specialCharactersRegex.test(value)) {
      toast.info("Special characters not allowed", {
        position: "bottom-right",
      });
      return;
    }
    if (
      !mappingOptions.some((option) => option.label === value.toUpperCase())
    ) {

      //add via api

      const endp = `${version}/save_header_details/`;
      try {
        const response = await apiInstance.post(endp, {
          project_id: details.project_code,
          header_name: value,
        });
        console.log(response.data)
        if (response.statusText === "OK") {
          fetchMappingOptions();
          toast.success("Added sucessfully, select the option again");
        }
      } catch (e) {
        handleApiError(e)
        console.log(e);
      }
    } else {
      toast.info("Entered value already exists", {
        position: "bottom-right",
      });
    }

  };

  useEffect(() => {
    fetchMappingOptions();
    setIsSinglePage(
      details && details.scraper_type ? true : false
    );
    if (details && details.headers) {
      setKeyValueMap(details.headers);
      setKeyValueMapFinal(details.headers);
    }
  }, [details]);
  function hasDuplicateValues(obj) {
    const valueOccurrences = {};
    for (const key in obj) {
      const value = obj[key].toLowerCase();
      if (valueOccurrences[value]) {
        return true;
      } else {
        valueOccurrences[value] = true;
      }
    }

    return false;
  }
  const updateKeyValueMap = async () => {


    const updatedKeyValueMap = { ...keyValueMap };
    for (const key in updatedKeyValueMap) {
      if (
        updatedKeyValueMap.hasOwnProperty(key) &&
        updatedKeyValueMap[key] === ""
      ) {
        delete updatedKeyValueMap[key];
      }
    }
    if (hasDuplicateValues(updatedKeyValueMap)) {
      toast.error("Duplicates not allowed");
      return;
    }
    setKeyValueMap(updatedKeyValueMap);

    const endp = `${version}/update_headers/`;

    try {
      const response = await apiInstance.post(endp, {
        scraper_id: details.url_id,
        headers: updatedKeyValueMap,
      });

      if (response.statusText === "OK") {
        toast.success("Headers updated successfully");
        setOpenHeaderspopup(false);
        setKeyValueMapFinal(response.data.data.headers);
      }
    } catch (e) {
      handleApiError(e)
      console.log(e);
    }
  };
  const ResetKeyValueMap = async () => {
    if (Object.values(keyValueMap).every(value => value === "")) {
      toast.error("Column headers are already in their original state. No modifications detected.");
      return;
    }
    const updatedKeyValueMap = { ...keyValueMap };
    for (const key in updatedKeyValueMap) {
      if (
        updatedKeyValueMap.hasOwnProperty(key) &&
        updatedKeyValueMap[key] === ""
      ) {
        delete updatedKeyValueMap[key];
      }
    }
    setKeyValueMap(updatedKeyValueMap);
    const url = `${version}/reset_headers/`;
    try {
      const response = await apiInstance.post(url, {
        scraper_id: details.url_id
      });

      if (response.statusText === "OK") {
        toast.success("Headers reset successfully");
        // setTimeout(() => {
        //   window.location.reload()
        // // }, 2000);
        // setKeyValueMap(response.data.data.headers);
        urlidAPI("pending")
        
      }
    } catch (e) {
      handleApiError(e)
      console.log(e);
    }
  };
  const fetchMappingOptions = async () => {
    if (!details.project_code) return;

    const url = `${version}/get_headers/${details.project_code}`;
    try {
      const response = await apiInstance.get(url, null);

      if (response.statusText === "OK") {
        let tempArray = response.data.headers.map((obj) => {
          return { label: obj };
        }).sort((a, b) => a.label.localeCompare(b.label));
        setMappingOptions(tempArray);
        console.log(mappingOptions)
      }
    } catch (e) {
      console.log(e);
    }
  };

  const [refresh, setRefresh] = useState(false);

  const [files, setFiles] = useState([]);

  const [schedule, enableScheduler] = useState(false);
  const [cronexp, setCronExp] = useState("");
  // row data
  const [rowData, setRowData] = useState();

  const [imageModal, setImageModal] = useState(false)
  const [currImage, setCurrImage] = useState("")


  useEffect(() => {
    let flagCheck = true;
    for (let i = 0; i < files.length; i++) {
      if (files[i].status != "approved") {
        flagCheck = false;
      }
    }

  }, [files]);
  // header row
  const [colDefs] = useState([
    { headerName: "Seq", field: "seq", minWidth: 60, flex: 1 },
    { headerName: "Command", field: "command", minWidth: 100, flex: 1 },

    { headerName: "XPath", field: "xpath", minWidth: 110, flex: 3 },
    {
      headerName: "Prompts",
      field: "prompts",
      minWidth: 180,
      flex: 2,
    },
    { headerName: "Comments", field: "comments", minWidth: 250, flex: 2 },
  ]);

  const handleRadioChange = (event) => {
    setSelectedOption(event.target.value);
  };

  const handleClickOpenHeaderspopup = async (value) => {
    await fetchJSONAPI(value);
    value.status === "approved"
      ? setCheckVisible(false)
      : setCheckVisible(true);
    setOpenHeaderspopup(true);
  };

  const [currPromptIndex, setCurrPromptIndex] = useState(null);
  const handleClickOpenResend = async (value, index) => {
    console.log(index);
    setRefresh(!refresh);
    console.log(rowData, "data")
    setCurrPrompt(rowData[index - 1].prompts);
    setCurrPromptIndex(index - 1);
    await fetchJSONAPI(value);
    setOpenResendforPreview(true);
  };

  function getValuesFromKeys(keysArray, obj) {
    return keysArray.map(key => obj[key]).filter(value => value !== undefined);
  }

  const handlePromptUpdate = async () => {
    if (currPrompt == "") {
      toast.error("Prompt cannot be empty");
      return;
    }
    let message = "Prompt updated successfully";
    const endp = `${version}/update_prompt_comment_info`;
    // console.log(,"keys")
    // return
    const data = {
      url_id: urlid,
      step_id: `${currPromptIndex + 1}`,
      update_type: "prompt",
      prompt: currPrompt,
      existing_headers_keys: getValuesFromKeys(dataKeys, keyValueMapFinal),
    };
    if (currPromptAdd != "") {
      data.update_type = "additional_prompt";
      data.additional_prompt = currPromptAdd;
      message = "Additional prompt updated successfully";
      if (currPrompt != rowData[currPromptIndex].prompts) {
        data.update_type = "combined_additional_prompt";
        message = "Prompt & additional prompt updated successfully";
      }
    }
    try {
      const response = await apiInstance.patch(endp, data);
      if (response.statusText === "OK") {
        setCurrPromptAdd("");

        if (openResendforPreview) {
          setOpenResendforPreview(false);
          toast.success(`${message}`);
          setTimeout(() => {
            setRefresh(!refresh);

          }, 2000);
        } else {
          toast.success("Resent for preview");
        }
      }
    } catch (error) {
      setCurrPromptAdd("");
      console.error("Error sending PATCH request:", error);
      handleApiError(error)
    }
  };

  const handleClickOpenRemovepopup = () => {
    setOpenRemovepopup(true);
  };

  const handleClickOpenRunOnce = () => {
    setOpenRunOnce(true);
  };

  const handleCloseRunOnce = () => {
    setOpenRunOnce(false);
  };

  const handleCloseConfirmCornSchedulepopup = () => {
    setOpenConfirmCornSchedulepopup(false);
  };
  const handleCloseConfirmSchedulePopup = () => {
    setConfirmSchedulePopup(false);
  };

  const handleCloseUsn = () => {
    let updation = { ...update };
    updation["scrapper_name"] = temp;
    updateAPI(updation);

    setUsnOpen(false);
    setTemp("");
    setSure(false);
    setUpdate({});
  };

  const handleApprove = (id) => {
    approveAPI(id);

  };

  const handleClickOpenOutputHistory = async (value, details1, type, setIsDownloading,status,snapshot_url) => {
    await fetchJSONOutputHistory(value, details1, type, setIsDownloading);
    setStatusHistory(status)
    setSnapshotUrl(snapshot_url)
    if (type.includes("pre")) setOpenDownload(true);
  };
  const handleDownload = (data, fileName, type) => {
    if (version == "v2") {
      if (!data) {
        setDownloadingState(false)
        return
      }
      const link = document.createElement("a");
      link.href = data;
      link.download = fileName;
      document.body.appendChild(link);
      link.click();
      setTimeout(() => {
        setDownloadingState(false)
      }, 1000);
      toast.success("Download started successfully")
      document.body.removeChild(link);
      return;
    }

    const jsonData = JSON.stringify(data);
    let blob = new Blob([jsonData], { type: "application/json" });
    if (type == "logs") {
      blob = new Blob([data], { type: "text/plain" });
    }
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();

    document.body.removeChild(link);
  };

  const fetchJSONOutputHistory = async (value, details1, type, setIsDownloading) => {
    const url = `${version}/preview_json_data`;
  
    try {
      if (version === "v2") {
        await handleV2Request(value, details1, type, setIsDownloading, url);
      } else {
        await handleLegacyRequest(value, type);
      }
    } catch (e) {
      console.log(e);
    }
  };
  
  const handleV2Request = async (value, details1, type, setIsDownloading, url) => {
    const response = await apiInstance.post(url, {
      prj_id: `${details1.project_code}`,
      json_bucket_file_path: cleanBucketPath(value.json),
      log_bucket_file_path: cleanBucketPath(value.log),
    });
  
    if (response.statusText !== "OK") return;
  
    let tempValue = type.includes("log") ? value.log : value.json;
    if (!tempValue) tempValue = "none";
    
    if (setIsDownloading) setIsDownloading(false);
    
    const fileNameDownload = extractFileName(tempValue);
    
    if (type.includes("json")) {
      setFileData({
        data: response.data.preview,
        id: tempValue.id,
        type,
        fileName: fileNameDownload,
        presigned_url: response.data.json_presigned_url,
      });
    } else {
      const logContent = await extractLogsFromUrl(response.data.log_presigned_url);
      setFileData({
        data: logContent,
        id: tempValue.id,
        type,
        fileName: fileNameDownload,
        presigned_url: response.data.log_presigned_url,
      });
    }
  
    setCheckVisible(false);
    handleDownloadIfRequired(type, response, fileNameDownload);
  };
  
  const handleLegacyRequest = async (value, type) => {
    let tempValue = type.includes("log") ? value.log : value.json;
    const response = await axios.get(tempValue);
  
    if (response.statusText !== "OK") return;
  
    const fileNameDownload = extractFileName(tempValue);
    setFileData({
      data: response.data,
      id: tempValue.id,
      type,
      fileName: fileNameDownload,
    });
  
    handleDownloadIfRequired(type, response, fileNameDownload);
  };
  
  const extractFileName = (path) => {
    const parts = path.replace(process.env.REACT_APP_BUCKET_URL, "").split("/");
    return parts[parts.length - 1];
  };
  
  const cleanBucketPath = (path) => {
    return path.replace(process.env.REACT_APP_BUCKET_URL, "");
  };
  
  const handleDownloadIfRequired = (type, response, fileNameDownload) => {
    if (!type.includes("pre")) {
      const fileUrl = type === "logs"
        ? response.data.log_presigned_url
        : response.data.csv_presigned_url || response.data.json_presigned_url;
      handleDownload(fileUrl, fileNameDownload, type);
    }
  };  

  useEffect(() => {
    if (outputHistoryData?.some(data => data?.status == "Scheduled" || data?.status == "In_progress")) {
      setTimeout(() => {
        urlidAPI("pending")
      }, 100000)
    }
  }, [outputHistoryData])

  const urlidAPI = async (status) => {
    const endp = `${version}/get_url_data?url_id=${urlid}&status_type=${status}`;
    try {
      const response = await apiInstance.get(endp);
      if (response.statusText === "OK") {
        setOutputHistory(
          dataFormatterOutputHistory(
            response.data.schedular_history
              ? response.data.schedular_history
              : []
          )
        );
        setRowData(dataFormatter(response.data.xpath_master));
        setActivitylogs(response.data.activity_logs);
        response.data.transactions
          ? setFiles(jsonFilePath(response.data.transactions))
          : console.log("no transactions");
        setDetails(response.data);
        checkDownload(response.data);
      }
    } catch (e) {
      setRowData([]);
      console.log(e);
    }
  };

  useEffect(() => {
    console.log("refreshing due to refresh", refresh);
    urlidAPI("pending");
  }, [urlid, update, refresh]);

  function getAllUniqueKeys(obj, keys = new Set()) {
    if (typeof obj === "object" && obj !== null) {
      if (Array.isArray(obj)) {
        for (const item of obj) {
          getAllUniqueKeys(item, keys);
        }
      } else {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            keys.add(key);
            getAllUniqueKeys(obj[key], keys);
          }
        }
      }
    }
    return Array.from(keys);
  }

  const fetchJSONAPI = async (value) => {
    const endp = `${version}/preview_json_data`;

    try {
      if (version == "v2") {
        const response = await apiInstance.post(endp, {
          prj_id: `${details.project_code}`,
          json_bucket_file_path: value.path,
        });

        if (response.statusText === "OK") {
          setDataKeys(getAllUniqueKeys(response.data.preview));
          setFileData({ data: response.data.preview, id: value.id });
        }
      } else {
        const response = await axios.get(
          process.env.REACT_APP_BUCKET_URL + value.path
        );
        if (response.statusText === "OK") {
          setFileData({ data: response.data, id: value.id });
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const approveAPI = async (tid) => {
    const endp = `${version}/approve-transaction/?transaction_id=${tid}&approved_by=${session.employeeCode}`;
    setFiles((prev) =>
      prev.map((i) => ({
        path: i.path,
        id: i.id,
        status: i.status,
        loader: i.id === tid ? true : false,
      }))
    );
    try {
      const response = await apiInstance.post(endp, null);
      if (response.statusText === "OK") {
        setFiles((prev) =>
          prev.map((i) => ({
            path: i.path,
            id: i.id,
            status: i.id === tid ? "approved" : i.status,
            loader: false,
          }))
        );
        toast.success("Data approved");
        if (!isSinglePage) {
          setOpenHeaderspopup(false);
        }
        setCheckVisible(false);
        // setFiles([])
        urlidAPI("pending")
      }
    } catch (e) {
      handleApiError(e)
    }

  };

  const removeAPI = async () => {
    const endp = `${version}/delete_scrapper`;
    const data = {
      url_id: urlid,
      emp_code: session.employeeCode,
      disable_flag: false,
    };
    try {
      const response = await apiInstance.patch(endp, data);
      if (response.statusText === "OK") {
        console.log("PATCH request successful:", response.data);
        toast.success("Scraper removed successfully");
        setTimeout(() => {
          history.push(`/${pushVersion}`);
        }, 2000);
      }
    } catch (error) {
      console.error("Error sending PATCH request:", error);
      handleApiError(e)
    }
  };

  const updateAPI = async (data) => {
    const message =
      data.update_type === "prompt"
        ? `Prompt updated successfully & resend for preview`
        : data.update_type === "comment"
          ? "Comment updated successfully"
          : "Scraper Name updated successfully";
    const endp = `${version}/update_prompt_comment_info`;

    try {
      const response = await apiInstance.patch(endp, data);
      if (response.statusText === "OK") {
        if (!openResendforPreview2) {
          toast.success(`${message}`);
          setTimeout(() => {
            setRefresh(!refresh);
          }, 2000);

        } else {
          toast.success("Resent for preview");
        }
      }
    } catch (error) {
      console.error("Error sending PATCH request:", error);
      handleApiError(e)
    }
  };

  const schedulerAPI = async (value) => {
    if (cronRegex.test(value)) {
      const urlcron = encodeURIComponent(value);

      const endp = `${version}/schedule-task/?url_id=${urlid}&chrone_expression=${urlcron}&schedule_by=${session.employeeCode}`;

      try {
        const response = await apiInstance.post(endp, null);
        if (response.statusText === "OK") {
          toast.success(`Succesfully scheduled scraper for ${urlid}`);
          setTimeout(() => {

            history.push(`/${pushVersion}`);
          }, 2000);
        }
      } catch (e) {
        console.log(e);
        handleApiError(e)
      }
    }
  };

  useEffect(() => {
    const allFilesApproved = files.every((file) => file.status === "approved");
    if (allFilesApproved) {
      enableScheduler(true);
    } else {
      enableScheduler(false);
    }
    if (
      files.some(
        (file) => file.status == "in_progress" || file.status == "pending"
      )
    ) {
      setTimeout(() => {
        urlidAPI("pending");
      }, 100000);
    }
  }, [files]);

  // header and row height
  const dataBoxWidth = (details.scraper_type != "SINGLE_PAGE") ? 2.4 : 3;

  const getScraperDetails = (details) => {
    if (
      details.urls_data &&
      details.urls_data.length > 0 &&
      details.scraper_type === "PAGINATION"
    ) {
      return transformString(
        `${details.scraper_type} > ${details.pagination_type} > ${details.data_source_type} > MULTI_URL`
      );
    }
  
    if (details.scraper_type === "PAGINATION") {
      return transformString(
        `${details.scraper_type} > ${details.pagination_type} > ${details.data_source_type}`
      );
    }
  
    if (
      details.urls_data &&
      details.urls_data.length > 0 &&
      details.scraper_type === "NO_PAGINATION"
    ) {
      return transformString("NO_PAGINATION > MULTI_URL");
    }
  
    if (details.file_download_flag) {
      return "File Download";
    }
  
    if (details.scraper_type) {
      return transformString(details.scraper_type);
    }
  
    return "";
  };  

  const getActionChanges = (activity) => {
    if (activity.action_changes && activity.action_changes.new_changes) {
      if (['RE-SCHEDULE', 'SCHEDULE'].includes(activity.action_type)) {
        return typeof activity.action_changes.new_changes === 'string'
          ? cronToText(activity.action_changes.new_changes) + "."
          : formatFrequencyData(activity.action_changes.new_changes);
      }
      if (activity.action_type === 'RENAME_COLUMN') {
        return "";
      }
      if (activity.action_type === 'CODE_CHANGES') {
        return "";
      }
      return "New " + activity.action_msg + ": " + activity.action_changes.new_changes + ".";
    }
    return "";
  };

  return (
    <>
      <Header />
      <Box id="page-container">
        <Container maxWidth>
          <Grid container spacing={1} mb={1} justifyContent="center">
            <Grid item lg={12} md={12} sm={12} xs={12}>
              <Box className="fx_sb_mob">
                <Box>
                  <Typography variant="h4" className="col1 fw5 ">
                    Pending Scraper Details
                  </Typography>
                </Box>
                <Box className="fx_fs margin_10">
                  <Box mr={2}>
                    <Button
                      className="approve_btn"
                      onClick={() => {

                        history.push('/');
                        // window.close()
                      }}
                    >
                      Back
                    </Button>
                  </Box>
                  <Box mr={2}>
                    <Button className="approve_btn" onClick={handleClickOpenRemovepopup}>
                      Remove
                    </Button>
                  </Box>
                  <Box>
                    <Button className="approve_btn" onClick={handleClickOpenal}>
                      Activity Logs
                    </Button>
                  </Box>
                </Box>
              </Box>
            </Grid>
          </Grid>

          <Grid container justifyContent="center" spacing={1}>
            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg1'>
                  <IconButton
                    disableRipple
                    onClick={() => {
                      window.open(details.website_url, "_blank");
                    }}
                  >
                    <LinkIcon fontSize="small" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      {urlid}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                      title={details.website_url ? details.website_url : "-"}
                    >
                      {details.website_url ? details.website_url : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg1'>
                  <IconButton
                    disableRipple
                    onClick={() => {
                      setTemp(
                        details.scraper_name ? details.scraper_name : "-"
                      );
                      setSure(false);
                      setUpdate({
                        url_id: urlid,
                        update_type: "scrapper_name",
                        scrapper_name: details.scraper_name
                          ? details.scraper_name
                          : "-",
                      });
                      setUsnOpen(true);
                    }}
                  >
                    <EditButton
                      fontSize="large"
                      className="wh card_icon4"
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scraper Name{" "}
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {details.scraper_name ? details.scraper_name : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg1'>
                  <IconButton disableRipple disabled>
                    <DescriptionIcon
                      fontSize="large"
                      className="wh card_icon4"
                    />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Scraper Type
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {getScraperDetails(details)}
                      </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>

            <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
              {/* <Link to="#"> */}
              <Box className="cardbx fx_sb" p={0}>
                <Box className='iconbx iconbx_2 cbg1'>
                  <IconButton disableRipple disabled>
                    <TodayIcon fontSize="large" className="wh card_icon4" />
                  </IconButton>
                </Box>
                <Box>
                  <Box className="al_right" m={1} p={1}>
                    <Typography variant="h6" className=" col1 card_title one">
                      Created On
                    </Typography>
                    <Typography
                      variant="h5"
                      className=" gray card_subtitle one"
                    >
                      {details.added_on
                        ? dateFormatter(details.added_on)
                        : "-"}
                    </Typography>
                  </Box>
                </Box>
              </Box>
              {/* </Link> */}
            </Grid>
            {(details.scraper_type != "SINGLE_PAGE") && (
              <Grid item lg={dataBoxWidth} md={6} sm={6} xs={12}>
                {/* <Link to="#"> */}
                <Box className="cardbx fx_sb" p={0}>
                  <Box
                    onClick={() => { (details.urls_data && details.urls_data.length > 0) ? setOpenUpdateUrl(true) : setOpenUpdateUrl(false) }}
                    className='iconbx iconbx_2 cbg1'
                  >
                    <IconButton disableRipple>
                      <EditNoteIcon
                        fontSize="large"
                        className="wh card_icon4"
                      />
                    </IconButton>
                  </Box>
                  <Box>
                    <Box className="al_right" m={1} p={1}>
                      <Typography
                        variant="h6"
                        className=" col1 card_title one"
                      >
                        Number of URLs
                      </Typography>
                      <Typography
                        variant="h5"
                        className=" gray card_subtitle one"
                      >
                        {(details.urls_data && details.urls_data.length > 0) ? details.urls_data.length : "-"}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
                {/* </Link> */}
              </Grid>
            )}
          </Grid>

          <Grid container justifyContent="center" spacing={1}>
            <Grid item lg={7} md={7} sm={12} xs={12}>
              <Box className="whitebx" mt={1}>
              <ScrappingCommands page="pending" temp={temp} urlid={urlid} rowData={rowData} setTemp={setTemp} setUpdate={setUpdate} update={update} updateAPI={updateAPI}/>
              </Box>
              <Box className="whitebx" mt={1}>
                <Output_History_Table
                  response_data={outputHistoryData}
                  on_preview={handleClickOpenOutputHistory}
                  on_download={handleClickOpenOutputHistory}
                  details={details}
                  isDownloadable={isDownloadable}
                // response_data={[]}
                />
                {version == "v2" && (
                  <Box mt={2} className="al_right">
                    <Button
                      disabled={files.some((file) => file.status != "approved")}
                      onClick={() => handleClickOpenRunOnce()}
                      className="run_scraper_btn"
                    >
                      {" "}
                      Run Scraper{" "}
                    </Button>
                  </Box>
                )}
              </Box>
            </Grid>

            <Grid item lg={5} md={5} sm={12} xs={12}>
              <Grid container justifyContent="center" spacing={1}>
                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box className="whitebx" mt={1}>
                    <Box className="heading_bx">
                      <Typography variant="h6" className=" col1 card_title ">
                        {isSinglePage
                          ? "Step 1: Data Preview, Approval, and Key Renaming (if necessary)"
                          : "Step 1: Data Preview and Approval"}
                      </Typography>
                    </Box>

                    <Box className="preview_mainbx">
                      {files.map((file, index) =>
                        file.id ? (
                          <Box className="preview_bx al_center " p={1} key={index} >
                            <Box>

                              <Typography
                                variant="h6"
                                className="one bl xstext  "
                              >
                                {file.status.startsWith("error")
                                  ? "Status: Failed"
                                  : "Status: " +
                                  file.status.charAt(0).toUpperCase() +
                                  file.status.slice(1).toLowerCase()}
                              </Typography>
                              <Typography
                                variant="h6"
                                className="card_preview_heading bl xstext"
                              >
                                {file.status === "approved" ||
                                  file.status === "completed"
                                  ? fileName(file.path)
                                  : file.status.startsWith("error")
                                    ? "Change prompt and try again"
                                    : "Preview In Pending"}
                              </Typography>
                            </Box>
                            <Box mt={2}>
                              <Tooltip
                                title={
                                  file.path
                                    ? file.status === "approved"
                                      ? "Approved"
                                      : "Pending for Approve"
                                    : null
                                }
                                arrow
                                style={{
                                  display:
                                    file.status.startsWith("error") ||
                                      file.status == "pending"
                                      ? "none"
                                      : "inline-flex",
                                }}
                              >
                                {" "}
                                <IconButton
                                  style={{
                                    backgroundColor:
                                      file.status === "approved"
                                        ? "green"
                                        : "#1930ab",
                                  }}
                                  disabled={true}
                                >
                                  {file.loader ? (
                                    <Box className="loadingbtn-container3"  >
                                      <Box className="dot3" />
                                    </Box>
                                  ) : (
                                    <CheckIcon
                                      className="approve_icon"
                                      style={{ color: "white" }}
                                    />
                                  )}
                                </IconButton>
                              </Tooltip>
                              <Tooltip
                                style={{
                                  display:
                                    file.status.startsWith("error") ||
                                      file.status == "pending"
                                      ? "none"
                                      : "inline-flex",
                                }}
                                title="Preview"
                                arrow
                              >
                                <IconButton
                                  onClick={() => handleClickOpenHeaderspopup(file)}
                                  disabled={
                                    file.path
                                      ? file.status === "in_progress"
                                        ? true
                                        : false
                                      : true
                                  }
                                  className="eye_btn"
                                >
                                  <Visibility
                                    fontSize="medium"
                                    className="wh approve_icon "
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Resend for preview" arrow>
                                {file.status == "pending" ?
                                  <Box ml={4} className="loadingbtn-container2"  >
                                    <Box className="dot2" />
                                  </Box>
                                  :
                                  <IconButton
                                    disabled={
                                      file.status == "in_progress" ||
                                      file.status == "pending"
                                    }
                                    onClick={() => {
                                      handleClickOpenResend(
                                        file,
                                        parseInt(
                                          fileName(file.path ? file.path : file.html_path).split("_")[2]
                                        )
                                      );
                                    }}
                                    className="repeat_btn"
                                  >
                                    {file.status == "in_progress" ||
                                      file.status == "pending" ? (
                                      <Box className="loadingbtn-container3"  >
                                        <Box className="dot3" />
                                      </Box>
                                    ) : (
                                      <RepeatIcon
                                        fontSize="medium"
                                        className="wh approve_icon "
                                      />
                                    )}
                                  </IconButton>
                                }
                              </Tooltip>
                              {localStorage.getItem("techLead") == "true" &&
                                <Tooltip
                                  style={{
                                    display:
                                      (file.status != "approved" && file.status != "completed")
                                        ? "none"
                                        : "inline-flex",


                                  }}
                                  title="Code"
                                  arrow
                                >
                                  <IconButton
                                    onClick={() => { handleOpenEditor(file, details) }}
                                    disabled={
                                      file.path
                                        ? (file.status != "approved" && file.status != "completed")
                                          ? true
                                          : false
                                        : true
                                    }
                                    className="eye_btn"
                                  >
                                    <CodeIcon
                                      fontSize="medium"
                                      className="wh approve_icon "

                                    />
                                  </IconButton>
                                </Tooltip>
                              }
                            </Box>
                          </Box>
                        ) : null
                      )}
                    </Box>
                  </Box>
                </Grid>

                <Grid item lg={12} md={12} sm={12} xs={12}>
                  <Box className="whitebx2 schedule relative">
                    <Box className="heading_bx fx_sb_mob">
                      <Box className="">
                        <Typography variant="h6" className=" col1 card_title ">
                          Step 3: Scheduling of Scraper
                        </Typography>
                      </Box>

                      <Box>
                        <FormControl>
                          <RadioGroup
                            row
                            aria-labelledby="demo-row-radio-buttons-group-label"
                            name="row-radio-buttons-group"
                            value={selectedOption}
                            onChange={handleRadioChange}
                          >
                            <FormControlLabel
                              value="b"
                              control={<Radio />}
                              label="Using Date, Time & Frequency"
                            />
                            <FormControlLabel
                              value="a"
                              control={<Radio />}
                              label="Using Cron Expression"
                            />
                          </RadioGroup>
                        </FormControl>
                      </Box>
                    </Box>

                    {
                      selectedOption === "a" ? (
                        <Box className="cron_expression" my={2}>
                          <Grid container justifyContent="center" spacing={1}>
                            <Grid item lg={12} md={12} sm={12} xs={12}>
                              <FormControl fullWidth className="input_field">
                                <FilledInput
                                  className="textfield_cron"
                                  id="filled-adornment-password"
                                  placeholder="Enter Cron Expression"
                                  onChange={(event) => {
                                    setCronExp(event.target.value);
                                  }}
                                />
                              </FormControl>
                              <Box mt={1} className="al_left">
                                <Typography variant="h6" className="gray desc">
                                  {" "}
                                  Note: A cron expression is a string
                                  representing a schedule in a time-based job
                                  scheduling system (like Unix cron). It is
                                  typically made up of five or six fields,
                                  separated by space, that represent different
                                  units of time.
                                </Typography>

                                <Typography
                                  variant="h6"
                                  className="xstext"
                                  mt={1}
                                >
                                  {" "}
                                  Example: A cron expression 0 12 * * Mon means
                                  the task will run at 12:00 PM every Monday.
                                  Learn more{" "}
                                  <a
                                    href="https://crontab.guru/"
                                    className="a_underline"
                                    target="_blank"
                                  >
                                    click here
                                  </a>
                                </Typography>
                              </Box>
                            </Grid>
                          </Grid>

                          <Box className="bottom-fixed-stack">
                            <Stack direction={"row"} spacing={1} alignItems={"center"} justifyContent="flex-end">
                              <Button
                                className="approve_btn"
                                disabled={!schedule || !cronRegex.test(cronexp)}
                                onClick={() => {
                                  setOpenConfirmCornSchedulepopup(true);
                                }}
                              >
                                Schedule
                              </Button>
                            </Stack>
                          </Box>

                        </Box>
                      ) : (
                        <Schedule_Using_Date_Time_Frequency_2
                          urlid={urlid}
                          schedule_flag={schedule}
                          emp_code={session ? session.employeeCode : null}
                          reschedule_flag={false}
                          version={version}

                          pageType="pending"
                          allowed={
                            files.some((file) => file.status == "approved") &&
                            isLatestObjectCompleted(outputHistoryData)
                          }
                        />
                      )

                    }
                  </Box>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Container>
      </Box>
      {/* modal box download */}

      <Box className="data preview">
        <Dialog
          open={openDownload}
          onClose={() => setOpenDownload(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="md"
          fullWidth
        >

          <DialogHeader
            heading={fileData.type && fileData.type.includes("logs") ? "Logs" : "Data Preview"}
            onClose={() => {
              setOpenDownload(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <Editor
                    height="400px"
                    defaultLanguage="text"
                    value={
                      fileData.type && fileData.type.includes("logs")
                        ? fileData.data
                        : JSON.stringify(fileData.data, null, 2)
                    }
                    options={{
                      minimap: {
                        enabled: false,

                      },
                      wordWrap: 'on'
                    }}
                  />
                </Box>

                <Box py={1}>
                  {fileData.presigned_url != undefined && (
                    <Box className="al_right" py={1} display="flex" flexDirection="row" justifyContent="flex-end" gap={2}>
                    {fileData.type.includes("logs") &&  
                    StatusHistory === "Failed" && SnapshotUrl && (
                        <Box>
                        <Button
                          onClick={() =>{
                            setCurrImage(SnapshotUrl)
                            setImageModal(true)
                          } 
                        }
                          className="approve_btn"
                        >
                          Check Snapshot
                        </Button>
                      </Box>)}
                      {isDownloadingState ? <LoadingBtn /> :
                        <Button
                          autoFocus
                          className="approve_btn"
                          onClick={() => {
                            setDownloadingState(true)
                            handleDownload(
                              fileData.presigned_url,
                              fileData.fileName,
                              fileData.type
                            );
                          }}
                        >
                          Download
                        </Button>
                      }
                    </Box>
                  )}
                </Box>

              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box >
      {/* modal box2 */}

      < Box className="data preview" >
        <Dialog
          open={openHeaderspopup}
          onClose={() => {
            setOpenHeaderspopup(false);
            setKeyValueMap(keyValueMapFinal);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth={
            details && details.scraper_type && !isDownloadable ? "md" : "xs"
          }
          fullWidth
        >

          <DialogHeader
            heading="Data Preview"
            onClose={() => {
              setOpenHeaderspopup(false);
              setKeyValueMap(keyValueMapFinal);
            }}
          />

          <Box my={1} className="data_preview">
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                <Grid
                  container
                  spacing={2}
                  alignItems="top"
                  justifyContent="center"
                >
                  <Grid
                    item
                    lg={isSinglePage && !isDownloadable ? 6 : 12}
                    md={isSinglePage && !isDownloadable ? 6 : 12}
                    sm={isSinglePage && !isDownloadable ? 6 : 12}
                    xs={12}
                  >
                    <Box className=" text_area ">
                      <Box className="input_field datapreview_bx">
                        <TextField
                          id="filled-basic"
                          className="filleddp padding0"
                          variant="filled"
                          multiline
                        
                          name="message"
                          fullWidth
                          value={JSON.stringify(fileData.data, null, 2)}
                          InputProps={{
                            readOnly: true,
                          }}
                          InputLabelProps={{
                            shrink: true,
                          }}
                        />
                      </Box>

                      {checkVisible ? (
                        <Box pt={1}>
                          <Stack direction={"row"} spacing={1} justifyContent={"space-between"} alignItems={"center"}>
                            <Box className="checkbox">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    name="Are you sure"
                                    checked={csure}
                                    onChange={() => {
                                      setSure(!csure);
                                    }}
                                    size="10px"
                                  />
                                }
                                label={
                                  <span style={{ fontSize: "12px" }}>
                                    Are you sure you want to approve?
                                  </span>
                                }
                              />
                            </Box>

                            <Button
                              onClick={() => handleApprove(fileData.id)}
                              autoFocus
                              disabled={!csure}
                              className="approve_btn"
                            >
                              Approve
                            </Button>

                          </Stack>
                        </Box>
                      ) : null}
                    </Box>
                  </Grid>
                  {(details && details.scraper_type && !isDownloadable) && (
                    <Grid item lg={6} md={6} sm={6} xs={12}>
                      <Box className="datapreview_bx schedule">
                        {dataKeys.map((data, index) => {
                          const filteredOptions = mappingOptions.filter(
                            (option, index, self) => {
                              const isOptionIncluded = Object.values(keyValueMap).includes(option.label);
                              const isUniqueOption = index === self.findIndex((o) => o.label === option.label);
                              const isSpecialCase = option.label.startsWith(option.label[0]);
                              return (!isOptionIncluded || isSpecialCase) && isUniqueOption;
                            }
                          );
                          return (
                            <HeaderMappingBox key={index}
                              data={data}
                              filteredOptions={filteredOptions}
                              keyValueMap={keyValueMap}
                              handleApplyMapping={handleApplyMapping}
                              handleDataKeyChange={handleDataKeyChange}
                              keyValueMapFinal={keyValueMapFinal}
                              handleRemoveOption={handleRemoveOption}
                              mappingOptions={mappingOptions}
                            />
                          );
                        })}
                      </Box>
                      <Box pt={1}>
                        <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                          <Box className="checkbox">
                            <FormControlLabel
                              control={
                                <Checkbox
                                  name="Are you sure"
                                  checked={csure2}
                                  onChange={() => {
                                    setSure2(!csure2);
                                  }}
                                  size="10px"
                                />
                              }
                              label={
                                <span style={{ fontSize: "12px" }}>
                                  Are you sure you want to rename keys?
                                </span>
                              }
                            />
                          </Box>
                          <Box>
                          <Button
                            onClick={() => updateKeyValueMap()}
                            autoFocus
                            disabled={!csure2}
                            className="approve_btn"
                          >
                            Update
                          </Button>
                          </Box>
                          <Box>
                          <Button
                              onClick={() => setOpenResetHeadersconfirmation(true)}
                              autoFocus
                              className="approve_btn"
                            >
                              Reset Headers
                            </Button>
                          </Box>
                        </Stack>
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </DialogContentText>
            </DialogContent>
          </Box>
        </Dialog >
      </Box >
      <CodeDisplayModal />
      {/* activity log */}

        <Dialog
          onClose={handleCloseal}
          aria-labelledby="customized-dialog-title"
          open={openal}
          maxWidth="xs"
          fullWidth
        >


          <DialogHeader
            heading="Activity Logs"
            onClose={handleCloseal}
          />


          <DialogContent className="history_drawer">
            <Box>
              <List>
                {activitylogs.map((activity, index) => (
                  <>
                    <ListItem key={index} disablePadding>
                      <ListItemAvatar>
                        <Avatar style={{ backgroundColor: "#00b0f0" }}>
                          <QueryBuilderIcon fontSize="small" /> {/* You can replace ImageIcon with the desired icon */}
                        </Avatar>
                      </ListItemAvatar>
                      <ListItemText
                        primary={
                            <Tooltip arrow title={<>
                              {(activity.action_by_emp_id === session.employeeCode ? "You" : activity.action_by)}{" "}
                              <strong>
                                {activity.action_type === "RENAME_COLUMN" ? (
                                  <>
                                    {"updated output preview keys"}
                                    <br />
                                    <br />
                                    <span style={{ marginTop: '3px' }}>
                                      {`Updated headers:  ${activity.action_changes ? JSON.stringify(activity.action_changes.new_changes) : '-'
                                        }`}
                                    </span>
                                  </>
                                ) : (
                                  activity.action_msg
                                )}
                              </strong>
                              {"."}
                              {getActionChanges(activity)}
                            </>}>
                              <Typography variant='h6' className='bl xtext lg2 fw4 one'>
                                {(activity.action_by_emp_id === session.employeeCode ? "You" : activity.action_by)}{" "}
                                <strong>
                                  {activity.action_type === "RENAME_COLUMN" ? (
                                    <>
                                      {"updated output preview keys"}
                                      <br />
                                      <br />
                                      <span style={{ marginTop: '3px' }}>
                                        {`Updated headers:  ${activity.action_changes ? JSON.stringify(activity.action_changes.new_changes) : '-'
                                          }`}
                                      </span>
                                    </>
                                  ) : (
                                    activity.action_msg
                                  )}
                                </strong>
                                {"."}
                                {getActionChanges(activity)}
                              </Typography>
                            </Tooltip>
                        }
                        secondary={
                            <Typography variant='h6' className='bl xtext lg fw4'>
                              {activity.action_on.includes('T') ? dateFormatter(activity.action_on) : formatDateString(activity.action_on)}
                            </Typography>
                        }
                      />
                    </ListItem>
                    <Box py={'4px'}>
                      <Divider />
                    </Box>
                  </>
                ))}
              </List>
            </Box>
          </DialogContent>
          {/* <DialogActions>
                        <Button className='sendbtn wh' onClick={handleCloseal}>
                            Save changes
                        </Button>
                    </DialogActions> */}
        </Dialog>
      {/* update scraper name modal */}
      <Box className="data preview">
        <Dialog
          open={usnOpen}
          onClose={() => setUsnOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading="New Scraper Name :"
            onClose={() => setUsnOpen(false)}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area" pb={1}>
                <Box className="input_field" pb={1}>
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={2}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={temp}
                    onChange={(event) => setTemp(event.target.value)}
                  />
                </Box>
                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>

                  <Box className="checkbox">
                    <FormControlLabel
                      control={
                        <Checkbox
                          name="Are you sure"
                          checked={csure}
                          onChange={() => {
                            setSure(!csure);
                          }}
                          size="small"
                        />
                      }
                      label={
                        <span style={{ fontSize: "12px" }}>
                          Are you sure you want to update?
                        </span>
                      }
                    />
                  </Box>


                  <Button
                    onClick={() => {
                      handleCloseUsn();
                    }}
                    autoFocus
                    className="approve_btn"
                    disabled={!csure || temp === ""}
                  >
                    Update
                  </Button>

                </Stack>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box>

      {/* remove alert dialog */}

      <Box className="data preview">
        <Dialog
          open={openRemovepopup}
          onClose={() => {
            setOpenRemovepopup(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={remove}
                      alt="remove"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to remove?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  removeAPI();
                  setOpenRemovepopup(false);
                }}
                autoFocus
                className="approve_btn"
              >
                Ok
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() => {
                  setOpenRemovepopup(false);
                }}
                autoFocus
                className="cancel_btn"
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      <Box className="data preview">
        <Dialog
          open={imageModal}
          onClose={() => {
            setImageModal(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          PaperProps={{
            style: {
              width: '1200px', // Set the desired width here
              height: '600px', // Set the desired height here (80% of the viewport height)
              maxWidth: 'none', // Ensures that maxWidth isn't limited by the `maxWidth` prop
            },
          }}

        >
          <DialogHeader
            heading=""
            onClose={() => {
              setImageModal(false);
            }}
          />


          <DialogContent >
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>

                  <img
                    src={currImage}
                    alt="preview"

                    style={{
                      width: '100%',    // Ensure the image takes up the full width
                      height: 'auto',   // Ensure the image takes up the full height

                    }}
                  />

                </Box>

              </Box>
            </DialogContentText>
          </DialogContent>

        </Dialog>
      </Box>
      {
        (details.scraper_type != "SINGLE_PAGE") && (
          <UpdateUrlModal
            open={openUpdateUrl}
            setOpen={setOpenUpdateUrl}
            details={details}
            version={version}
            refresh={refresh}
            setRefresh={setRefresh}
          />
        )
      }

      {/* Schedule cron exp */}
      <Box className="data preview">
        <Dialog
          open={confirmCornSchedulepopup}
          onClose={handleCloseConfirmCornSchedulepopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to schedule?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  schedulerAPI(cronexp);
                }}
                autoFocus
                className="approve_btn"
              >
                Schedule
              </Button>
            </Box>
            <Box>
              <Button onClick={handleCloseConfirmCornSchedulepopup} autoFocus className="cancel_btn">
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      {/* Schedule Modal Date Time Frequency*/}

      <Box className="data preview">
        <Dialog
          open={confirmSchedulePopup}
          onClose={handleCloseConfirmSchedulePopup}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to schedule?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  schedulerAPI(generateCronExpression(expvalues));
                  setConfirmSchedulePopup(false);
                }}
                autoFocus
                className="approve_btn"
              >
                Schedule
              </Button>
            </Box>
            <Box>
              <Button onClick={handleCloseConfirmSchedulePopup} autoFocus className="cancel_btn">
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      {/* Run Once Modal */}
      <Box className="data preview">
        <Dialog
          open={openRunOnce}
          onClose={handleCloseRunOnce}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Re-Schedule"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to run scraper once ?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={async () => {
                  await runScraperOnce(urlid, session.employeeCode, version);
                  setOpenRunOnce(false)
                  urlidAPI("pending");
                }}
                autoFocus
                className="approve_btn"
              >
                Run Once
              </Button>
            </Box>
            <Box>
              <Button
                onClick={handleCloseRunOnce}
                autoFocus
                className="cancel_btn"
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>

      {/* Resend For Preview */}
      <Box className="data preview">
        <Dialog
          open={openResendforPreview2}
          onClose={() => setOpenResendforPreview2(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="  al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={resend}
                      alt="Resend"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to resend for preview ?
                </Typography>
              </Box>
            </DialogContentText>
          </DialogContent>
          <Box className="fx_c" mb={2}>
            <Box mr={1}>
              <Button
                onClick={() => {
                  updateAPI(update);
                  setOpenResendforPreview2(false);
                  setRefresh(!refresh);
                  pressCtrlR();
                }}
                autoFocus
                className="approve_btn"
              >
                Resend
              </Button>
            </Box>
            <Box>
              <Button
                onClick={() => setOpenResendforPreview2(false)}
                autoFocus
                className="cancel_btn"
              >
                Cancel
              </Button>
            </Box>
          </Box>
        </Dialog>
      </Box>
      {/* Reset Headers Confirmation*/}
      < Box className="data preview" >
        <Dialog
          open={openResetHeadersconfirmation}
          onClose={() => {
            setOpenResetHeadersconfirmation(false);
          }}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="al_center" my={4}>
                <Box mb={2}>
                  <Box>
                    <img
                      src={scheduling}
                      alt="Reset Headers"
                      className="remove_icon_gif"
                    />
                  </Box>
                </Box>
                <Typography variant="h5" className="gray fw6">
                  Are you sure you want to reset attributes keys?
                </Typography>
              </Box>
              <Box className="fx_c" mb={2}>
                <Box mr={1}>
                  <Button
                    onClick={() => {
                      ResetKeyValueMap();
                      setOpenResetHeadersconfirmation(false);
                    }}
                    autoFocus
                    className="approve_btn"
                  >
                    Ok
                  </Button>
                </Box>
                <Box>
                  <Button
                    onClick={() => {
                      setOpenResetHeadersconfirmation(false);
                    }}
                    autoFocus
                    className="cancel_btn"
                  >
                    Cancel
                  </Button>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog>
      </Box >
      {/* Resend For Preview */}
      <Box className="data preview">
        <Dialog
          open={openResendforPreview}
          onClose={() => setOpen(false)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          maxWidth="xs"
          fullWidth
        >

          <DialogHeader
            heading="Data Preview"
            onClose={() => {
              setOpenResendforPreview(false);
            }}
          />

          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              <Box className="text_area">
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={4}
                    maxRows={4}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={JSON.stringify(fileData.data, null, 2)}
                  />
                </Box>
                <Box pt={2}>
                  <Typography variant="h6" className=" col1 card_title " gutterBottom>
                    Existing Prompt <span style={{ color: "red" }}>*</span>
                  </Typography>
                </Box>
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    disabled={currPrompt == "Downloadable Links" || currPrompt == "LIST_ITEM" || currPrompt == "DATA_SOURCE" || currPrompt == "PAGINATION_SOURCE" || currPrompt == "Hyperlinks"}
                    value={currPrompt}
                    onChange={(event) => setCurrPrompt(event.target.value)}
                  />
                </Box>
                <Box pt={2}>
                  <Typography variant="h6" className=" col1 card_title " gutterBottom>
                    Additional Prompt (Optional)
                  </Typography>
                </Box>
                <Box className="input_field">
                  <TextField
                    id="filled-basic"
                    className="filleddp padding0"
                    variant="filled"
                    multiline
                    minRows={1}
                    name="message"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    value={currPromptAdd}
                    onChange={(event) => setCurrPromptAdd(event.target.value)}
                  />
                </Box>
                <Box pt={1} pb={1}>
                  <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>

                    <Box className="checkbox">
                      <FormControlLabel
                        control={
                          <Checkbox
                            name="Are you sure"
                            checked={csure}
                            onChange={() => {
                              setSure(!csure);
                            }}
                            size="10px"
                          />
                        }
                        label={
                          <span style={{ fontSize: "12px" }}>
                            Are you sure you want to update?
                          </span>
                        }
                      />
                    </Box>

                    <Button
                      onClick={() => {
                        handlePromptUpdate();
                      }}
                      autoFocus
                      className="approve_btn"
                      disabled={!csure}
                    >
                      Update & Resend
                    </Button>

                  </Stack>
                </Box>
              </Box>
            </DialogContentText>
          </DialogContent>
        </Dialog >
      </Box >
      <ToastContainer
        position="top-center"
        style={{ fontSize: "16px", width: "400px", height: "200px" }}
      />
      <Footer />
    </>
  );
};

export default Pending_Details_Page;

function pressCtrlR() {
  window.location.reload();
}
